module.exports = {"id":"162932","name":"Pablo Barrientos","rating":"74","photo":"./data/images/photos/3/162932.png","club":{"name":"Toluca","logo":"./data/images/clubs/Toluca.png"},"positions":["MOC","MC","MG"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/PabloBarrientos0.json
// module id = 3339
// module chunks = 0